{
	"domain-model": {
		"activeFollowUpPlan": {
			"list": {
				"emptyData": {
					"title": "Geen actieve opvolgplannen",
					"message": "Er zijn momenteel geen actieve opvolgplannen."
				}
			}
		},
		"assessment": {
			"list": {
				"emptyData": {
					"title": "Geen schalen",
					"message": "Er zijn nog geen schalen."
				}
			},
			"property": {
				"plannedDate": {
					"label": "Geplande datum",
					"placeholder": "Selecteer een datum"
				},
				"purpose": {
					"label": "Doelstelling"
				}
			}
		},
		"careFacility": {
			"list": {
				"emptyData": {
					"title": "Geen zorginstellingen gevonden",
					"message": "Er zijn geen zorginstellingen gevonden."
				}
			}
		},
		"closedFollowUpPlan": {
			"list": {
				"emptyData": {
					"title": "Geen gesloten opvolgplannen",
					"message": "Er zijn momenteel geen gesloten opvolgplannen."
				}
			}
		},
		"communication": {
			"list": {
				"emptyData": {
					"title": "Geen berichten gevonden",
					"message": "Er zijn geen berichten om weer te geven."
				},
				"search": {
					"placeholder": "Zoek berichten..."
				}
			},
			"property": {
				"attachments": {
					"label": "Bijlage(s)"
				},
				"from": {
					"label": "Van"
				},
				"message": {
					"label": "Bericht"
				},
				"recipients": {
					"label": "Ontvangers"
				},
				"sender": {
					"label": "Afzender"
				},
				"sentOn": {
					"label": "Datum"
				},
				"subject": {
					"label": "Onderwerp",
					"placeholder": "Vul een onderwerp in"
				},
				"to": {
					"label": "Aan",
					"placeholder": "Zoek een communicatiegroep"
				}
			}
		},
		"communicationGroup": {
			"list": {
				"emptySearch": {
					"title": "Geen communicatiegroepen gevonden",
					"message": "Er zijn geen communicatiegroepen gevonden die voldoen aan de zoekcriteria."
				}
			},
			"property": {
				"additionalContacts": {
					"label": "Gebruikers toevoegen",
					"guide": "Wil je individuele gebruikers toevoegen?",
					"hint": "Een aantal gebruikers werd reeds automatisch aan deze groep toegevoegd vanwege hun hoofdfunctie of toegang tot een huis.",
					"placeholder": "Kies gebruiker"
				},
				"description": {
					"label": "Beschrijving",
					"guide": "Wie kan je bereiken met deze communicatiegroep?",
					"placeholder": "Vul een beschrijving in"
				},
				"includedContacts": {
					"label": "Inbegrepen contacten",
					"guide": "Selecteer de contacten die in deze groep moeten worden opgenomen.",
					"placeholder": "Zoek contacten"
				},
				"includedGroups": {
					"label": "Inbegrepen groepen",
					"guide": "Selecteer de communicatiegroepen die in deze groep moeten worden opgenomen.",
					"placeholder": "Zoek communicatiegroepen"
				},
				"name": {
					"label": "Naam",
					"placeholder": "Vul een naam in"
				}
			}
		},
		"contact": {
			"list": {
				"emptySearch": {
					"title": "Geen contacten gevonden",
					"message": "Er zijn geen contacten gevonden die voldoen aan de zoekcriteria."
				}
			}
		},
		"document": {
			"list": {
				"emptyData": {
					"title": "Geen documenten",
					"message": "Er zijn nog geen documenten toegevoegd."
				}
			},
			"property": {
				"createdBy": {
					"label": "Door"
				},
				"createdOn": {
					"label": "Toegevoegd op"
				},
				"name": {
					"label": "Naam document"
				}
			}
		},
		"evaluation": {
			"list": {
				"emptyData": {
					"title": "Geen evaluaties",
					"message": "Er zijn nog geen evaluaties."
				}
			},
			"property": {
				"alternativeMeasures": {
					"label": "Andere acties"
				},
				"decisions": {
					"label": "Genomen beslissing",
					"placeholder": "Voeg een omschrijving toe"
				},
				"evaluationDate": {
					"label": "Datum evaluatie",
					"placeholder": "Selecteer datum"
				},
				"evaluationDecisions": {
					"label": "Beslissing"
				},
				"isolationMeasures": {
					"label": "Isolatiemaatregelen"
				},
				"notes": {
					"label": "Motivering van de beslissing",
					"placeholder": "Voeg een omschrijving toe"
				},
				"restrictiveMeasures": {
					"label": "Vrijheidsbeperkende maatregelen"
				},
				"subject": {
					"label": "Onderwerp",
					"empty": "Geen onderwerp",
					"placeholder": "Voeg een omschrijving toe"
				}
			}
		},
		"evaluationMeasure": {
			"list": {
				"emptyData": {
					"title": "Geen maatregelen",
					"message": "Er zijn nog geen maatregelen."
				}
			},
			"property": {
				"details": {
					"label": "Uitvoeringsdetails",
					"placeholder": "Voeg instructies of aandachtspunten toe"
				},
				"evaluationDate": {
					"label": "Datum evaluatie"
				},
				"followUpPlan": {
					"label": "Opvolgplan"
				},
				"name": {
					"label": "Maatregel"
				},
				"startDate": {
					"label": "Startdatum"
				}
			}
		},
		"evaluationMeasureAlternative": {
			"list": {
				"emptyData": {
					"title": "Geen alternatieve maatregelen",
					"message": "Er zijn nog geen alternatieve maatregelen."
				}
			}
		},
		"evaluationMeasureIsolation": {
			"list": {
				"emptyData": {
					"title": "Geen isolatiemaatregelen",
					"message": "Er zijn nog geen isolatiemaatregelen."
				}
			}
		},
		"evaluationMeasureRestriction": {
			"list": {
				"emptyData": {
					"title": "Geen vrijheidsbeperkende maatregelen",
					"message": "Er zijn nog geen vrijheidsbeperkende maatregelen."
				}
			},
			"property": {
				"reason": {
					"label": "Reden",
					"placeholder": "Voeg de reden toe"
				}
			}
		},
		"fallObservation": {
			"property": {
				"causes": {
					"label": "Oorzaken",
					"guide": "Wat veroorzaakte de val?",
					"placeholder": "Selecteer oorzaken"
				},
				"causesOther": {
					"label": "Andere oorzaken",
					"placeholder": "Voeg een omschrijving toe"
				},
				"consequences": {
					"label": "Gevolgen",
					"guide": "Wat zijn de gevolgen van de val?",
					"placeholder": "Selecteer gevolgen"
				},
				"consequencesOther": {
					"label": "Andere gevolgen",
					"placeholder": "Voeg een omschrijving toe"
				},
				"contexts": {
					"guide": "Wat deed de resident op het moment van de val?"
				},
				"correctiveActions": {
					"label": "Correctieve acties",
					"guide": "Welke acties werden ondernomen na de val?"
				},
				"correctiveActionsOther": {
					"label": "Andere correctieve acties",
					"placeholder": "Voeg andere correctieve acties toe"
				},
				"location": {
					"label": "Plaats",
					"guide": "Waar is de resident gevallen?",
					"placeholder": "Selecteer een plaats"
				},
				"locationOther": {
					"label": "Andere plaats",
					"placeholder": "Voeg een omschrijving toe"
				}
			}
		},
		"followUpPlan": {
			"list": {
				"emptyData": {
					"title": "Geen opvolgplannen",
					"message": "Er zijn nog geen opvolgplannen."
				},
				"emptySearch": {
					"title": "Geen opvolgplannen gevonden",
					"message": "Er zijn geen opvolgplannen gevonden die voldoen aan de zoekcriteria."
				}
			},
			"property": {
				"activeAlternativeMeasures": {
					"label": "Actieve alternatieve maatregelen"
				},
				"activeIsolationMeasures": {
					"label": "Actieve Isolatiemaatregelen"
				},
				"activeRestrictionMeasures": {
					"label": "Actieve vrijheidsbeperkende maatregelen"
				},
				"careTheme": {
					"label": "Zorgthema",
					"guide": "Selecteer het zorgthema dat bij dit opvolgplan past",
					"placeholder": "Voeg het zorgthema toe"
				},
				"careThemeOther": {
					"label": "Ander zorgthema",
					"placeholder": "Voeg een omschrijving toe"
				},
				"closedOn": {
					"label": "Afgesloten"
				},
				"createdOn": {
					"label": "Creatiedatum"
				},
				"department": {
					"label": "Afdeling"
				},
				"documents": {
					"label": "Documenten"
				},
				"followUp": {
					"label": "Opvolging"
				},
				"followUpDate": {
					"label": "Datum opvolging",
					"placeholder": "Selecteer een datum"
				},
				"linkedObservations": {
					"label": "Gekoppelde observaties"
				},
				"measures": {
					"label": "VBM/Isolatie",
					"empty": "-"
				},
				"name": {
					"label": "Opvolgplan"
				},
				"problemStatement": {
					"label": "Reden van opvolgplan",
					"guide": "Beschrijf waarom dit opvolgplan wordt opgestart",
					"placeholder": "Voeg de reden toe"
				},
				"resident": {
					"label": "Resident"
				},
				"title": {
					"label": "Titel opvolgplan",
					"guide": "Geef een korte, duidelijke titel aan het opvolgplan (max 50 tekens)",
					"placeholder": "Voeg de titel toe"
				}
			}
		},
		"hq": {
			"property": {
				"sites": {
					"empty": "Er zijn nog geen sites toegevoegd."
				},
				"supportInfo": {
					"empty": "Je hebt nog geen contactgegevens voor de interne helpdesk toegevoegd."
				}
			}
		},
		"incontinenceObservation": {
			"property": {
				"consequences": {
					"label": "Gevolgen",
					"guide": "Welke hygiëne- of comfortproblemen zijn vastgesteld?",
					"placeholder": "Selecteer gevolgen"
				},
				"consequencesOther": {
					"label": "Andere gevolgen",
					"placeholder": "Voeg een omschrijving toe"
				},
				"contexts": {
					"guide": "Wanneer trad de incontinentie op?"
				},
				"type": {
					"label": "Type incontinentie",
					"guide": "Wat is het type van de incontinentie?",
					"placeholder": "Selecteer een type"
				}
			}
		},
		"infectionObservation": {
			"property": {
				"severity": {
					"label": "Ernst",
					"guide": "Hoe ernstig zijn de symptomen?"
				},
				"symptoms": {
					"label": "Symptomen",
					"guide": "Welke symptomen van infectie vertoont de resident?"
				},
				"symptomsOther": {
					"label": "Andere",
					"placeholder": "Voeg een omschrijving toe"
				}
			}
		},
		"linkedObservation": {
			"list": {
				"emptyData": {
					"title": "Geen observaties gekoppeld",
					"message": "Er zijn nog geen observaties gekoppeld."
				}
			}
		},
		"observation": {
			"list": {
				"emptyData": {
					"title": "Geen observaties gevonden",
					"message": "Er zijn nog geen observaties geregistreerd."
				},
				"emptySearch": {
					"title": "Geen observaties gevonden",
					"message": "Er zijn geen observaties gevonden voor de geselecteerde filters."
				}
			},
			"property": {
				"contexts": {
					"label": "Context",
					"placeholder": "Selecteer contexten"
				},
				"contextsOther": {
					"label": "Andere context",
					"placeholder": "Voeg een omschrijving toe"
				},
				"createdBy": {
					"label": "Medewerker"
				},
				"createdOn": {
					"label": "Tijdstip van de\u00A0registratie"
				},
				"department": {
					"label": "Afdeling tijdens observatie",
					"unknown": "Onbekend"
				},
				"linkedObservations": {
					"label": "Gekoppelde observaties"
				},
				"notes": {
					"label": "Notities",
					"guide": "Voeg hier notities toe",
					"placeholder": "Voeg hier notities toe"
				},
				"observationType": {
					"label": "Type",
					"placeholder": "Selecteer een type"
				},
				"observedOn": {
					"label": "Tijdstip van de\u00A0observatie",
					"placeholder": "Selecteer datum en tijd"
				},
				"occurredOn": {
					"label": "Tijdstip van de\u00A0gebeurtenis"
				},
				"occurredOnDate": {
					"label": "Datum van de\u00A0gebeurtenis",
					"placeholder": "Selecteer datum"
				},
				"occurredOnPartOfDay": {
					"label": "Dagdeel",
					"placeholder": "Selecteer een dagdeel"
				},
				"resident": {
					"label": "Resident",
					"unknown": "Onbekende resident"
				}
			}
		},
		"organisingAuthority": {
			"list": {
				"emptyData": {
					"title": "Geen inrichtende machten gevonden",
					"message": "Er zijn geen inrichtende machten gevonden."
				}
			}
		},
		"permission": {
			"list": {
				"emptyData": {
					"title": "Geen permissies gevonden",
					"message": "Er zijn geen permissies gevonden."
				}
			}
		},
		"physicalComplaintObservation": {
			"property": {
				"complaintOther": {
					"label": "Andere",
					"placeholder": "Voeg een omschrijving toe"
				},
				"complaints": {
					"label": "Aard van de klachten",
					"guide": "Welke lichamelijke klachten heeft de resident?"
				},
				"severity": {
					"label": "Ernst",
					"guide": "Hoe ernstig zijn de klachten?"
				}
			}
		},
		"recipient": {
			"list": {
				"emptySearch": {
					"title": "Geen ontvangers gevonden",
					"message": "Er zijn geen ontvangers gevonden die voldoen aan de zoekcriteria."
				},
				"search": {
					"placeholder": "Zoek ontvanger..."
				}
			}
		},
		"resident": {
			"property": {
				"evaluationMeasuresActive": {
					"label": "Actieve maatregelen"
				},
				"evaluationMeasuresStopped": {
					"label": "Stopgezette maatregelen"
				},
				"firstName": {
					"label": "Voornaam"
				},
				"lastName": {
					"label": "Naam"
				}
			}
		},
		"role": {
			"list": {
				"emptyData": {
					"title": "Geen rollen gevonden",
					"message": "Er zijn geen rollen gevonden."
				}
			}
		},
		"site": {
			"list": {
				"emptyData": {
					"title": "Geen sites gevonden",
					"message": "Er zijn geen sites gevonden."
				}
			},
			"property": {
				"supportInfo": {
					"empty": "Je hebt nog geen contactgegevens voor de interne helpdesk toegevoegd."
				}
			}
		},
		"submittedAssessment": {
			"list": {
				"emptyData": {
					"title": "Geen afgenomen schalen",
					"message": "Er zijn nog geen schalen afgenomen."
				}
			},
			"property": {
				"createdBy": {
					"label": "Medewerker"
				},
				"createdOn": {
					"label": "Afnamedatum"
				},
				"details": {
					"label": "Details"
				},
				"documents": {
					"label": "Bijlagen"
				},
				"includeInBriefing": {
					"label": "Toegevoegd aan briefing?"
				},
				"notes": {
					"label": "Opmerkingen",
					"placeholder": "Voeg hier opmerkingen toe..."
				},
				"questionnaire": {
					"label": "Vragenlijst"
				},
				"resident": {
					"label": "Resident"
				},
				"score": {
					"label": "Score"
				},
				"totalScore": {
					"label": "Totaalscore"
				}
			}
		},
		"user": {
			"list": {
				"emptyData": {
					"title": "Geen gebruikers gevonden",
					"message": "Er zijn geen gebruikers gevonden."
				},
				"emptySearch": {
					"title": "Geen gebruikers gevonden",
					"message": "Er zijn geen gebruikers gevonden die voldoen aan de zoekcriteria."
				}
			}
		}
	}
}
